import { z } from 'zod';

export const auditFormSchema = z.object({
  // Company details
  company_name: z.string().min(1, 'Company name is required'),
  contact_name: z.string().min(1, 'Contact name is required'),
  email: z.string().email('Valid email is required'),
  industry: z.string().min(1, 'Industry is required'),

  // Processes & Workflows
  uses_paper: z.boolean(),
  double_data_entry: z.boolean(),
  has_sops: z.boolean(),
  onboarding_time: z.enum(['<1 day', '1–3 days', '>3 days']),
  most_time_consuming_tasks: z.string().min(1, 'Please select at least one time-consuming task'),

  // Systems & Tools
  current_systems: z.string().min(1, 'Current systems information is required'),
  duplicate_tools: z.boolean(),
  integrations_in_place: z.boolean(),
  uses_cloud_storage: z.boolean(),
  compliance_reporting_automatic: z.boolean(),

  // Communication & Collaboration
  uses_email_for_tasks: z.boolean(),
  approval_delays: z.boolean(),
  cross_dept_visibility: z.boolean(),
  client_self_service: z.boolean(),

  // Data & Reporting
  realtime_kpis: z.boolean(),
  reporting_automated: z.boolean(),
  report_prep_time: z.enum(['<1 hr/week', '1–5 hrs/week', '>5 hrs/week']),
  single_source_of_truth: z.boolean(),

  // Automation & AI
  repetitive_tasks_automated: z.boolean(),
  uses_ai: z.boolean(),
  has_automation_roi_strategy: z.boolean(),

  // Pain Points
  top_pain_points: z.string().optional(),
  wish_list: z.string().optional(),
});

export type AuditFormData = z.infer<typeof auditFormSchema>;

export interface AuditResult {
  score: number;
  zone: string;
  zoneColor: string;
  recommendations: string[];
  summary: string;
}